enum MemberFilterType {
  AccountType = 'accountType',
  InviteStatus = 'inviteStatus',
}

export const memberFilterTypes = Object.values(MemberFilterType)

export default MemberFilterType
